export default __webpack_public_path__ + "static/media/team-background.61386f8d.svg";